module.exports = __webpack_public_path__ + "static/media/pokemon.8c654110.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pokemon.jpg
// module id = 119
// module chunks = 0